import Api from '@/services/Api';
import Usuario from '@/model/Usuario';

const RECURSO = '/usuarios';
export default {
    newUsuario,
    getUsuario,
    getAllUsuario,
    getUsuarioVideoWall,
    getUsuarioPrivilegios,
    postUsuario,
    postUsuarioRetornar,
    putUsuario,
    ativarUsuario,
    desativarUsuario,
    buscarUsuarioLdapPorEmail
};

function newUsuario(id = 0, ativo = true, email =  '', nome = '', unidade = null, listaPerfil = [], username =''){
    return new Usuario(id, ativo,email,nome,unidade,listaPerfil, username);
}

function getUsuario (id) {
    return Api.get(`${RECURSO}/${id}`);
}

function getAllUsuario () {
    return Api.get(`${RECURSO}`);
}

function getUsuarioVideoWall(){
    return Api.get(`${RECURSO}/videowall`)
}

function getUsuarioPrivilegios (id) {
    return Api.get(`${RECURSO}/${id}/privilegios`);
}

function postUsuario(payload){
    return Api.post(`${RECURSO}`, payload);
}

function postUsuarioRetornar(payload){
    return Api.post(`${RECURSO}/retornar`, payload);
}

function putUsuario(payload){
    return Api.put(`${RECURSO}/${payload.id}`, payload);
}

function ativarUsuario(id){
    return Api.put(`${RECURSO}/${id}/ativar`);
}

function desativarUsuario(id){
    return Api.delete(`${RECURSO}/${id}/inativar`);
}

function buscarUsuarioLdapPorEmail(email){
    return Api.get(`${RECURSO}/ldap/${email}`);
}